module.exports = __webpack_public_path__ + "static/media/stp_card_cvc.5a40b06c.png";